var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2749 6.88452C17.6149 6.9443 17.842 7.26835 17.7822 7.60831L16.1197 17.0635C16.1197 17.0635 16.1197 17.0635 16.1197 17.0635C15.9271 18.1593 14.9753 18.9584 13.8627 18.9584H7.13728C6.02472 18.9584 5.0729 18.1593 4.88024 17.0636L3.21778 7.60831C3.158 7.26835 3.38514 6.9443 3.7251 6.88452C4.06507 6.82475 4.38912 7.05189 4.44889 7.39185L6.11136 16.8471C6.19893 17.3452 6.6316 17.7084 7.13728 17.7084H13.8627C14.3684 17.7084 14.8011 17.3452 14.8886 16.8471L16.5511 7.39185C16.6109 7.05189 16.9349 6.82475 17.2749 6.88452Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35417 2.29175C8.77887 2.29175 8.3125 2.75812 8.3125 3.33341V4.37508H12.6875V3.33341C12.6875 2.75811 12.2211 2.29175 11.6458 2.29175H9.35417ZM7.0625 4.37508V3.33341C7.0625 2.06776 8.08851 1.04175 9.35417 1.04175H11.6458C12.9115 1.04175 13.9375 2.06777 13.9375 3.33341V4.37508H18C18.3452 4.37508 18.625 4.6549 18.625 5.00008C18.625 5.34526 18.3452 5.62508 18 5.62508H3C2.65482 5.62508 2.375 5.34526 2.375 5.00008C2.375 4.6549 2.65482 4.37508 3 4.37508H7.0625Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d3729a00f2de52f6bc509a54bf5df199.svg";
export { ForwardRef as ReactComponent };